import { ActivatedRoute } from '@angular/router';
import { AdminService } from './../../_services/admin.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-device-sync-detail',
  templateUrl: './device-sync-detail.component.html',
  styleUrls: ['./device-sync-detail.component.css']
})
export class DeviceSyncDetailComponent implements OnInit {
  syncDetail={}
  syncResponse=""
  syncRequest=""
  constructor(private adminService:AdminService, private activatedRoute:ActivatedRoute) { }

  ngOnInit(): void {
   this.activatedRoute.params.subscribe(
     params=>{
        let id = params['id']
        this.adminService.getDeviceSyncById(id).subscribe(
          x=>{
          
            this.syncDetail=x
            this.syncRequest =JSON.stringify(this.syncDetail['syncrequest'])
            this.syncResponse =JSON.stringify(this.syncDetail['syncresponse'])
          }
        )
     }
   )
    
  }

}
